module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/check/check.component.css
// module id = ./src/app/legal/check/check.component.css
// module chunks = main